import React, { Component } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { compose } from 'recompose'
import _ from 'lodash'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import DashboardData from './dashboardData'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			scannedData: null
		}
	}

	componentDidMount() {
	}

	render() {
		const { scannedData } = this.state
		const { scanError } = this.props
		return (
			<Query query={DASHBOARD_DATA} variables={{ searchFilter: {} }}>
				{({ loading, error, subscribeToMore, data }) => {
					const mData = _.has(data, 'dashboardData') ? data.dashboardData : null
					return (
						<DashboardData
							scannedData={scannedData}
							error={scanError}
							dashboardData={mData}
							subscribeToNewLogs={() => {
								subscribeToMore({
									document: NEW_DASHBOARD_DATA,
									variables: { message_uid: 'aaaa' },
									updateQuery: (prev, { subscriptionData }) => {
										console.log('[NEW_MESSAGE] previous value', prev)
										console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
										if (!subscriptionData.data) return prev
										this.props.setScannedData(subscriptionData.data.newDashboardData.userParams)
										this.setState({ scannedData: subscriptionData.data.newDashboardData.userParams }, () => {
											var that = this
											setTimeout(() => {
												that.setState({ scannedData: null })
											}, 5000)
										})
										return Object.assign({}, prev, {
											dashboardData: { ...subscriptionData.data.newDashboardData.data }
										})
									}
								})
							}}
						/>
					)
				}}
			</Query>
		)
	}
}

const DASHBOARD_DATA = gql`
    query dashboardData($searchFilter: SearchParams) {
		dashboardData(searchFilter: $searchFilter)
    }
`

const NEW_DASHBOARD_DATA = gql`
	subscription newDashboardData($message_uid: String) {
		newDashboardData(message_uid: $message_uid)
	}
`

const composed = compose(
	observer
)

export default composed(Index)
